import React, {useEffect, useRef} from 'react';
import {translateRecord} from "../../../common/utils";
import Category from "./Category";
import {Collapse} from "react-bootstrap";

const PlatesView = (props) => {
  const refs = useRef({});
  const stickyRef = useRef(null);
  const hiddenCategoryRef = useRef(null);
  const navRef = useRef(null);
  const hiddenNavRef = useRef(null);
  const categoriesRef = useRef();
  const selectedCategory = props.menu.filter((c) => c.id === props.activeCategory)[0];

  useEffect(() => {
    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
  });

  const isSticky = () => {
    const navTab = navRef.current;
    const hiddenNav = hiddenNavRef.current;
    const hiddenElement = hiddenCategoryRef.current;
    const stickyElement = stickyRef.current;
    const scrollTop = window.scrollY;

    if (!!props.activeCategory) {
      const stickyTopPosition = hiddenElement.offsetTop - 80;
      if (scrollTop > stickyTopPosition) {
        hiddenElement.style.height = '86px';
        stickyElement.classList.add('is-sticky-category');
      } else {
        if (!!navTab) {
          hiddenNav.style.height = 0;
        }
        hiddenElement.style.height = 0;
        stickyElement.classList.remove('is-sticky-category');
      }
    } else {
      if (!!navTab) {
        hiddenNav.style.height = 0;
      }
      if (!!hiddenElement) {
        hiddenElement.style.height = '0';
      }
      if (!!stickyElement) {
        stickyElement.classList.remove('is-sticky-category');
      }
    }
  };

  //console.log('store', store)
  // console.log('state', state)
  // console.log('storeOrdersIndex', storeOrders)
  // console.log('isOperator', isOperator)
  // console.log('selectedOrderType', selectedOrderType)

  return (
    <>
      <div className=''>
        <div style={{height: 0}} ref={hiddenCategoryRef}/>
        <div ref={stickyRef}>
          <div className={!!props.activeCategory ? 'with-background' : `row card-body pt-0`} ref={categoriesRef}
               style={!!props.activeCategory ? {display: 'flex', flexWrap: 'nowrap', flexDirection: 'row',
                 alignItems: 'center', justifyContent: 'left', overflowX: 'scroll', padding: 0,
                 cursor: 'pointer'} : {}}
          >
            { props.menu.map((category, i) =>
              <div key={i} className={`${!props.activeCategory && 'col-4 col-sm-3 col-md-2'} position-relative`}
                   ref={(element) => {refs.current[category.type] = element}} style={{borderRadius: 10, padding: 5}}
              >
                { props.selectedDishesCount(category) > 0 &&
                  <div className='selected-dishes fs-16' style={{top: 0, right: -3, lineHeight: 1.5}}>
                    {props.selectedDishesCount(category)}
                  </div>}
                <div onClick={() => props.getCategoryDishes(category)}
                     className={`company-category menu-category`}
                     style={{backgroundSize: 'cover', backgroundPosition: 'center',
                       backgroundImage: `url(${category.photo})`,
                       width: !!props.activeCategory ? 80 : '100%',
                       boxShadow: props.activeCategory === category.id ? 'rgb(255, 161, 73) 0px 0px 0px 4px' : 'initial'}}
                >
                  <div className='d-flex align-items-end'
                       style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}
                  >
                    <p className='fs-16 mb-0 mr-1 text-white p-2' style={{lineHeight: 1, textAlign: 'left',
                      background: category.id === props.activeCategory ?
                        'linear-gradient(338deg, #FFA149, #FB4A35 111.32%)' : 'linear-gradient(136deg, rgba(21, 13, 3, 0.9) 15%, rgba(22, 15, 6, 0.824) 30%, rgba(24, 17, 9, 0.74) 40%, rgba(31, 22, 11, 0.14) 100%)',
                      borderTopRightRadius: 10, borderBottomLeftRadius: 10, overflowWrap: 'anywhere'}}
                    >
                      {translateRecord(category, 'content')}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
      { !!props.activeCategory &&
        <Collapse in={props.activeCategory === selectedCategory.id} className=''>
          <div className=''>
            { props.activeCategory === selectedCategory.id &&
              <Category category={selectedCategory}
                      selectedSubcategory={props.state.selectedSubcategory} refs={refs}
                      noPhoto={props.noPhoto} setState={props.setState} state={props.state}
                      handleDishOrderCount={props.handleDishOrderCount}
                      handleAddDishToOrder={props.handleAddDishToOrder}
                      selectDishVariation={props.selectDishVariation}
                      selectComplexDish={props.selectComplexDish}
                      dishParameter={props.dishParameter}
                      calculateCount={props.calculateCount}
                      table={props.table} company={props.company}
                      acceptOutsideOrders={props.acceptOutsideOrders}
                      countDishVariation={props.countDishVariation}
                      fromDashboard={props.fromDashboard}
                      restaurant={props.restaurant}/>}
          </div>
        </Collapse>}
    </>
  );
};

export default PlatesView;
